import { render, staticRenderFns } from "./CrearContenidoCurricula.vue?vue&type=template&id=b2887ff4&scoped=true"
import script from "./CrearContenidoCurricula.vue?vue&type=script&lang=js"
export * from "./CrearContenidoCurricula.vue?vue&type=script&lang=js"
import style0 from "./CrearContenidoCurricula.vue?vue&type=style&index=0&id=b2887ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2887ff4",
  null
  
)

export default component.exports